import type { Customer } from "types/customer"

/**
 * hide-automatic-detections customer feature (config.customer_feature): the
 * customer sees only manual detections, the ones people drew. The API enforces
 * it on every detection read (api/utils/automatic-detections.js), so lists,
 * maps, counts, Route View and exports are already manual-only; the app only
 * takes away what would be empty or meaningless with nothing automatic in it:
 * the AI Detected / Human Reported source filter, the coverage toggle (manual
 * detections always pass High-confidence, so useCoverageMode locks it), the
 * Signs mode and nav item (every sign is automatic), and the Dashboard's
 * detection counts (counted by the pipeline over every detection). Applies to
 * everyone, Route Reports staff included.
 */
// Dev-only preview of the hidden state without a DB row: load the app with
// ?hideAutomaticDetections=1. Captured once per page load (like the
// ?customerId dev pin) so it sticks across SPA navigations within the tab.
// The API's own switch for local testing is HIDE_AUTOMATIC_DETECTIONS_FOR.
const devForceHidden =
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("hideAutomaticDetections") === "1"

export function isAutomaticDetectionsHidden(customerData: Customer | undefined): boolean {
    if (devForceHidden) {
        return true
    }
    return customerData?.customerFeatures?.includes("hide-automatic-detections") ?? false
}
